import type { TOC } from '@ember/component/template-only';
import HotelOverviewDashboardTilesTopInsightsRatesChart from 'lumen/components/hotel/overview-dashboard/tiles/top-insights/rates-chart';

interface HotelOverviewDashboardTilesTopInsightsTabRatesChartSignature {
  Args: {
    params: unknown;
  };
}

const HotelOverviewDashboardTilesTopInsightsTabRatesChart = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <HotelOverviewDashboardTilesTopInsightsRatesChart
    @isLoading={{@params.isRatesLoading}}
    @isPerformanceChartVisible={{@params.isPerformanceChartVisible}}
    @onUpdateChartReference={{@params.onUpdateChartReference}}
    @otaId={{@params.otaId}}
    @otbData={{@params.otbData}}
    @priceDifferenceData={{@params.priceDifferenceData}}
    @priceOpportunityData={{@params.priceOpportunityData}}
    @pricePositionData={{@params.pricePositionData}}
    @rangeChanged={{@params.rangeChanged}}
    @rentalData={{@params.rentalData}}
    @selectedRange={{@params.selectedRange}}
    @selectedRefDaysAgo={{@params.selectedRefDaysAgo}}
    @toggleOrSetSelectedDay={{@params.toggleOrSetSelectedDay}}
  />
</template> satisfies TOC<HotelOverviewDashboardTilesTopInsightsTabRatesChartSignature>;

export default HotelOverviewDashboardTilesTopInsightsTabRatesChart;
